module.exports = __webpack_public_path__ + "static/media/kopila_on_bed.36f44184.png";